import { CommonModule } from '@angular/common';
import { Injector, NgModule } from '@angular/core';

import { MgEllipsisModule } from '@app/src/app/elements/MgEllipsis';
import { MgeIconModule } from '@app/src/app/elements/MgeIcon';
import { MgPipesModule } from '@app/src/app/pipes';

import { MgAnnouncementMiniCardElement } from './MgAnnouncementMiniCard.element';

@NgModule({
  imports: [
    // Minga dependencies
    MgeIconModule,
    MgEllipsisModule,
    MgPipesModule,

    // External dependencies
    CommonModule,
  ],
  declarations: [MgAnnouncementMiniCardElement],
  exports: [MgAnnouncementMiniCardElement],
})
export class MgAnnouncementMiniCardModule {
  constructor(injector: Injector) {
    if (!customElements.get('minga-announcement-mini-card')) {
      //       //   MgAnnouncementMiniCardElement,
      //   {injector},
      // ));
    }
  }
}
